import React from "react";

const ContactThree = () => {
return (
<>
  <section class="contact-info section-space-bottom">
    <div class="contact-info__bg boskery-jarallax" data-jarallax="" data-speed="0.3" style={{
            backgroundImage: "url(assets/images/shapes/contact-bg-1-1.png)",
          }}></div>
    <div class="container">
      <div class="row gutter-y-30">
        <div class="col-lg-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
          <div class="contact-info__contact">
            <div class="contact-info__contact__bg" style={{
                    backgroundImage:
                      "url(assets/images/shapes/contact-bg-1-1.png)",
                  }}></div>
            <div class="contact-info__contact__content">
              <div class="contact-info__top text-center">
                <h4 class="contact-info__title">
                  Bizimle İletişime Geçiniz Lütfen !
                </h4>
                <p class="contact-info__text contact-info__text--business-hours" style={{
                        color: "#111117",
                      }}>
                  Soru, görüş, öneri ve istekleriniz için bize ulaşabilirsiniz.
                </p>
              </div>
              <div class="contact-info__contact-list">
                <div class="contact-info__contact-list__item">
                  <span class="contact-info__contact-list__icon icon-phone-call"></span>
                  <div class="contact-info__contact-list__content">
                    <span class="contact-info__contact-list__title">
                      Telefon
                    </span>
                    <a href="tel:+905553735627" class="contact-info__contact-list__link">
                      (0555) 373 56 27
                    </a><br/>
                    <a href="tel:+905393636862" class="contact-info__contact-list__link">
                      (0539) 363 6862
                    </a>
                    
                  </div>
                </div>
                <div class="contact-info__contact-list__item">
                  <span class="contact-info__contact-list__icon icon-paper-plane"></span>
                  <div class="contact-info__contact-list__content">
                    <span class="contact-info__contact-list__title">
                      E-Mail
                    </span>
                    <a href="mailto:info@seymenkimya.com" class="contact-info__contact-list__link"
                      style={{ textTransform: "lowercase" }}>
                      info@seymenkimya.com
                    </a><br/>
                    <a href="mailto:info@seymenkimya.com" class="contact-info__contact-list__link"
                      style={{ textTransform: "lowercase" }}>
                      muhasebe@seymenkimya.com
                    </a>
                    <br/>
                    <a href="mailto:info@seymenkimya.com" class="contact-info__contact-list__link"
                      style={{ textTransform: "lowercase" }}>
                      satispazarlama@seymenkimya.com
                    </a>
                  </div>
                </div>
                <div class="contact-info__contact-list__item">
                  <span class="contact-info__contact-list__icon icon-maps-and-flags"></span>
                  <div class="contact-info__contact-list__content">
                    <span class="contact-info__contact-list__title">
                      Adres
                    </span>
                    <a href="../maps/place/যুক্তরাজ্য/@52.8973648,-24.2857502,5z/data=!3m1!4b1!4m6!3m5!1s0x25a3b1142c791a90xc4f8a0433288257a!8m2!3d55.378051!4d-3.435973!16zL20vMDdzc2M.html"
                      class="contact-info__contact-list__link">
                      Bursa Gıda Toptancılar Sitesi<br/>
                      Ertuğrul Mh. 105. Sk. No:2, 16120 <br/>Nilüfer/Bursa
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 wow fadeInUp text-center" data-wow-duration="1500ms" data-wow-delay="200ms">
          <div class="contact-info__business-hours">
            <div class="contact-info__business-hours__bg" style={{
                    backgroundImage:
                      "url(assets/images/shapes/contact-bg-1-1.png)",
                  }}></div>
            <div class="contact-info__business-hours__content">
              <div class="contact-info__top contact-info__top--business-hours">
                <h4 class="contact-info__title contact-info__title--business-hours">
                  Çalışma Saatlerimiz
                </h4>
                <p class="contact-info__text contact-info__text--business-hours">
                  Size yardımcı olmaktan mutluluk duyarız...
                </p>
              </div>
              <div class="contact-info__contact-list text-start">
                <div class="row">
                  {/* Sol Sütun */}
                  <div class="col-md-6">
                    <div class="contact-info__contact-list__items d-flex align-items-center mb-2">
                      <span class="contact-info__contact-list__icon icon-check me-3"></span>
                      <div class="contact-info__contact-list__content">
                        <div class="text-white">
                          Pazartesi{" "}
                          <span style={{ margin: "10px" }}> 08:00 - 18:00</span>{" "}
                        </div>
                      </div>
                    </div>
                    <div class="contact-info__contact-list__items d-flex align-items-center mb-2">
                      <span class="contact-info__contact-list__icon icon-check me-3"></span>
                      <div class="contact-info__contact-list__content">
                        <div class="text-white">
                          Salı{" "}
                          <span style={{ margin: "10px" }}> 08:00 - 18:00</span>{" "}
                        </div>
                      </div>
                    </div>
                    <div class="contact-info__contact-list__items d-flex align-items-center mb-2">
                      <span class="contact-info__contact-list__icon icon-check me-3"></span>
                      <div class="contact-info__contact-list__content">
                        <div class="text-white">
                          Çarşamba{" "}
                          <span style={{ margin: "10px" }}> 08:00 - 18:00</span>{" "}
                        </div>
                      </div>
                    </div>
                    <div class="contact-info__contact-list__items d-flex align-items-center mb-2">
                      <span class="contact-info__contact-list__icon icon-check me-3"></span>
                      <div class="contact-info__contact-list__content">
                        <div class="text-white">
                          Perşembe{" "}
                          <span style={{ margin: "10px" }}> 08:00 - 18:00</span>{" "}
                        </div>
                      </div>
                    </div>
                    <div class="contact-info__contact-list__items d-flex align-items-center mb-2">
                      <span class="contact-info__contact-list__icon icon-check me-3"></span>
                      <div class="contact-info__contact-list__content">
                        <div class="text-white">
                          Cuma{" "}
                          <span style={{ margin: "10px" }}> 08:00 - 18:00</span>{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Sağ Sütun */}
                  <div class="col-md-6">
                    
                    <div class="contact-info__contact-list__items d-flex align-items-center mb-2">
                      <span class="contact-info__contact-list__icon fas fa-times me-3" style={{color: 'red', fontSize: '20px'}}></span>
                      <div class="contact-info__contact-list__content">
                        <div class="text-white">
                          Cumartesi{" "}
                          <span style={{ margin: "10px" }}>  Kapalı</span>{" "}
                        </div>
                      </div>
                    </div>
                    <div class="contact-info__contact-list__items d-flex align-items-center mb-2">
                      <span class="contact-info__contact-list__icon fas fa-times me-3" style={{color: 'red', fontSize: '20px'}}></span>
                      <div class="contact-info__contact-list__content">
                        <div class="text-white">
                          Pazar <span style={{ margin: "10px" }}> Kapalı</span>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>
);
};

export default ContactThree;